import {
    PassengerFlightEstimateRequest,
    PassengerRailEstimateRequest,
    PassengerRoadEstimateRequest,
    TransactionDocumentEstimateTransportationLineItem,
} from '@lune-climate/lune'
import { TransactionDocumentEmissionEstimateLineItem } from '@lune-climate/lune/cjs/models/TransactionDocumentEmissionEstimateLineItem'
import { FC } from 'react'

import { assertType } from '../../utils/utils'

import PassengerTransportationEmissionExplanation from './PassengerTransportEmissionExplanation'

interface TransactionDocumentEmissionsExplanationLineItemSectionProps {
    lineItem: TransactionDocumentEstimateTransportationLineItem &
        Pick<TransactionDocumentEmissionEstimateLineItem, 'value' | 'mass'>
    enableEmissionFactorLink: boolean
    mapboxAccessToken?: string
}

export const TransactionDocumentEmissionsExplanationTransportationLineItemSection: FC<
    TransactionDocumentEmissionsExplanationLineItemSectionProps
> = ({ lineItem, enableEmissionFactorLink, mapboxAccessToken }) => {
    const {
        distance,
        route,
        passengers,
        item,
        emissionFactor: maybeEmissionFactor,
        mass,
    } = lineItem

    function getOriginalRequest():
        | PassengerFlightEstimateRequest
        | PassengerRoadEstimateRequest
        | PassengerRailEstimateRequest {
        let details
        if ('cabinClass' in lineItem) {
            details = {
                cabinClass: lineItem.cabinClass,
                flightIdentification: lineItem.flightIdentification,
            }
        } else if ('railType' in lineItem) {
            details = { railType: lineItem.railType }
        } else {
            assertType<PassengerRoadEstimateRequest>(lineItem)
            details = { vehicleType: lineItem.vehicleType }
        }
        return {
            route,
            ...details,
        }
    }
    const resolvedLegs = 'resolvedLegs' in lineItem ? lineItem.resolvedLegs : undefined
    const destination = resolvedLegs?.at(-1)?.destination

    return (
        <>
            <PassengerTransportationEmissionExplanation
                estimate={{
                    legs: [
                        {
                            mass,
                            distance,
                            emissionFactor: maybeEmissionFactor,
                            ...(resolvedLegs && resolvedLegs.length > 1 && destination
                                ? { route: { source: resolvedLegs[0].source, destination } }
                                : {}),
                        },
                    ],
                    requestLegs: [getOriginalRequest()],
                }}
                enableEmissionFactorLink={enableEmissionFactorLink}
                inferenceDetails={{
                    item,
                    passengers,
                }}
                leg={0}
                estimateType={'transaction_document'}
                mapboxAccessToken={mapboxAccessToken}
            />
        </>
    )
}
